<template>
	<div class='address-picker'>
		<div class='grid address-grid'>
		<!-- <button @click='test'>test</button> -->
			<div>
				<span>Федеральный округ</span>
				<custom-p-select
					v-model='selectedFo'
					:options='foList'
					:loading='loadingFoList'
					:disabled='loadingFoList'
				/>

			</div>

			<div>
				<span>Субъект РФ</span>
				<custom-p-select
					v-model='selectedRegion'
					:options='regionList'
					:loading='loadingRegionList'
					:disabled='loadingRegionList || !selectedFo'
				/>
			</div>

			<div>
				<span>Лесничество</span>
				<custom-p-select
					v-model='selectedForestry'
					:options='forestryList'
					:loading='loadingForestryList'
					:disabled='loadingForestryList || !selectedRegion'
				/>
			</div>

			<div>
				<span>Участковое лесничество</span>
				<custom-p-select
					v-model='selectedLocalforestry'
					:options='localforestryList'
					:loading='loadingLocalforestryList'
					:disabled='loadingLocalforestryList || !selectedForestry'
				/>
			</div>

			<div>
				<span>Урочище / дача</span>
				<custom-p-select
					v-model='selectedSubforestry'
					:options='subforestryList'
					:loading='loadingSubforestryList'
					:disabled='loadingSubforestryList || !selectedLocalforestry'
				/>
			</div>

			<div>
				<span>Квартал</span>
				<custom-p-select
					v-model='selectedArea'
					:options='areaList'
					:loading='loadingAreaList'
					:disabled='loadingAreaList || !selectedSubforestry'
				/>
			</div>

			<div>
				<span>Выдел</span>
				<custom-p-input v-model='selectedSection' :disabled='!selectedArea'/>
			</div>

		</div>

		<button @click='checkTax' v-if='selectedSection && taxExists === null'>Проверить наличие ТО</button>
		<div class='no-tax-alert'><span v-if='taxExists === false'>Таксационное описание данного выдела не внесено в систему</span></div>
		<button @click='addTax' v-if='selectedSection && taxExists === false' class='add-tax-btn'>Ввести ТО по материалам действующего лесоустройства</button>
		<button @click='goToCreateLpo' v-if='selectedSection && taxExists' :disabled='!checkTaxFill.flag' class='add-tax-btn'>Перейти к созданию ЛПО</button>
		<PMessage v-if="!checkTaxFill.flag" severity="warn" :closable="false">Заполнены не все обязательные поля ({{checkTaxFill.comments}})</PMessage>
		<!-- <button @click='getTaxTemp'>Получить 1111</button> -->
	</div>
</template>

<script>
	const CHECK_TAX = process.env.VUE_APP_ROOT_API + 'check_tax.php';

	import { mapState, mapMutations, mapActions } from 'vuex';

	export default {
		name: 'TaxAddressPicker',

		data: () => ({
			taxExists: null,

			tax_id: null,
		}),

		computed: {
			checkTaxFill() {
				const tax = this.$store.state.taxInfo['selectedTax']
				let comments = []
				let flag = true
				if(tax.length > 0) {
					if(!tax[0]['forest_inventory_year']) {
					comments.push('Не указан год лесоустройства')
					flag = false
					}
					if(!tax[0]['bonitet']) {
						comments.push('Не указан бонитет')
						flag = false
					}
					if(!tax[0]['bonitet']) {
						comments.push('Не указан бонитет')
						flag = false
					}
					if(!tax[0]['s']) {
						comments.push('Не указана площадь выдела')
						flag = false
					}
					if(tax[0]['forest_purpose_id'] == "1" && !tax[0]['protection_category_id'])
					{
						comments.push('Не указана категория защитности')
						flag = false
					}
					if(!tax[0]['forest_purpose_id'])
					{
						comments.push('Не указано целевое назначение')
						flag = false
					}
					tax.forEach((item) => {
						if (!item['non_forest_land_id'] && !item['unforested_land_id']) {
							if(!item['composition']) {
								comments.push((item.layer == "11" ? "Единичные деревья": "Ярус " + item.layer) + ': не указан состав')
								flag = false
							}
							if(!item['stock'] > 0) {
								comments.push((item.layer == "11" ? "Единичные деревья": "Ярус " + item.layer) + ': не указан запас сырорастущий')
								flag = false
							}
							if(!item['fullness'] && parseInt(item['layer']) < 11) {
								comments.push('Ярус '+ item.layer + ': не указана полнота яруса')
								flag = false
							}
							if(!item['coeff'] || !item['species_name'] || !item['species_name']) {
								comments.push('Не заполнены данные по породе')
								flag = false
							}
						} /*else if (item['unforested_land_id']) {
							if(!(item['stock'] > 0)) {
								comments.push((item.layer == "11" ? "Единичные деревья": "Ярус " + item.layer) + ': не указан запас сырорастущий')
								flag = false
							}
						}*/
					})
				}
				const uComments = [...new Set(comments)].join(', ')
				return {flag, comments: uComments}
			},
			selectedFo: {
				get() { return this.$store.state.taxInfo.address['selectedFo']; },
				set(value) { this.selectFo(value); }
			},
			selectedRegion: {
				get() { return this.$store.state.taxInfo.address['selectedRegion']; },
				set(value) { this.selectRegion(value); }
			},
			selectedForestry: {
				get() { return this.$store.state.taxInfo.address['selectedForestry']; },
				set(value) { this.selectForestry(value); }
			},
			selectedLocalforestry: {
				get() { return this.$store.state.taxInfo.address['selectedLocalforestry']; },
				set(value) { this.selectLocalforestry(value); }
			},
			selectedSubforestry: {
				get() { return this.$store.state.taxInfo.address['selectedSubforestry']; },
				set(value) { this.selectSubforestry(value); }
			},
			selectedArea: {
				get() { return this.$store.state.taxInfo.address['selectedArea']; },
				set(value) { this.selectArea(value); }
			},
			selectedSection: {
				get() { return this.$store.state.taxInfo.address['selectedSection']; },
				set(value) { this.setSelectedSection(value); }
			},

			...mapState('taxInfo/address', {
				foList: state => state['foList'],
				regionList: state => state['regionList'],
				forestryList: state => state['forestryList'],
				localforestryList: state => state['localforestryList'],
				subforestryList: state => state['subforestryList'],
				areaList: state => state['areaList'],

				loadingFoList: state => state.loadingFoList,
				loadingRegionList: state => state.loadingRegionList,
				loadingForestryList: state => state.loadingForestryList,
				loadingLocalforestryList: state => state.loadingLocalforestryList,
				loadingSubforestryList: state => state.loadingSubforestryList,
				loadingAreaList: state => state.loadingAreaList,
				loadingSectionList: state => state.loadingSectionList,
			})
		},

		watch: {
			selectedSection(val) {
				this.taxExists = null;
				this.clearTax();
			}
		},

		methods: {
			goToCreateLpo() {
				console.log('go to create lpo');
				// const lpo = this.lpo;

				const route_obj = {
					name: 'create-lpo',
					params: {
						from_tax: true,

						fo: this.selectedFo,
						region: this.selectedRegion,
						forestry: this.selectedForestry,
						localforestry: this.selectedLocalforestry,
						subforestry: this.selectedSubforestry,
						area: this.selectedArea,
						section: {
							id: this.tax_id,
							name: this.selectedSection
						}
					}
				};
				this.$router.push(route_obj);
			},

			test() {
				console.log(this.$route);
			},

			getTaxTemp() {
				this.$toast.open({
					message: 'get 1111',
					type: 'warning'
				});

				const tax_id = '131e0201-4fae-4e21-a015-268056e1d186';
				this.getTax(tax_id);
			},

			checkTax() {
				const form = new FormData();
				form.append('locality_id', this.selectedArea.id);
				form.append('section', this.selectedSection);

				fetch(CHECK_TAX, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					const tax_id = res.czl_search_tax;

					if (tax_id) {
						this.getTax(tax_id);
						this.taxExists = true;
						this.tax_id = tax_id;
					} else {
						this.clearTax();
						this.taxExists = false;
					}
				})
				.catch(err => console.log(err));
			},

			addTax() {
				this.createTax().then(res => {
					this.checkTax();
				});
			},


			...mapMutations('taxInfo/address', [
				'setSelectedSection'
			]),

			...mapActions('taxInfo/address', [
				'selectFo',
				'selectRegion',
				'selectForestry',
				'selectLocalforestry',
				'selectSubforestry',
				'selectArea',

				'selectLocalforestryGoFromLpo',

				'getFoList',
			]),

			...mapMutations('taxInfo', [
				'clearTax'
			]),

			...mapActions('taxInfo', [
				'getTax',
				'createTax'
			])
		},

		created() {
			console.log(this.$store.state.taxInfo['selectedTax']);
			this.getFoList();

			const params = this.$route.params;
			if (params['lpo_id']) {
				this.getTax(params['tax_id']);

				this.selectFo(params['fo']);
				this.selectRegion(params['region']);
				this.selectForestry(params['forestry']);
				this.selectLocalforestryGoFromLpo(params['localforestry']);
				this.selectSubforestry(params['subforestry']);
				this.selectArea(params['area']);
				this.setSelectedSection(params['section']);
			}

			if (params['from_create']) {
				this.selectFo(params['fo']);
				this.selectRegion(params['region']);
				this.selectForestry(params['forestry']);
				this.selectLocalforestryGoFromLpo(params['localforestry']);
				this.selectSubforestry(params['subforestry']);
				this.selectArea(params['area']);
				// this.setSelectedSection(params['section']);
			}
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>

<style scoped>
	.v-text-field >>> input {
		font-size: 14px;

	}

	.address-picker {
		margin-bottom: 70px;
	}

	.address-grid {
		margin-bottom: 10px;
	}

	.no-tax-alert {
		font-style: italic;
		margin-bottom: 10px;
	}

</style>